import RbvDialogService from 'root/v-components/_core/rbv-dialog/RbvDialogService';
import RbvNotificationService from 'root/v-components/_core/rbv-notifications/RbvNotificationService';
import DialogService from 'root/services/modals/DialogService.js';

export const Notification = new RbvNotificationService();
export const Dialog = new RbvDialogService();
export const SvelteDialog = new DialogService();
